
<template>
    <b-tabs pills card vertical>
        <b-tab v-for="(section, sidx) in rest.sections" :key="sidx" :active="section.is_active">
            <template #title>
                <div class="fs-lg px-4 text-center d-flex justify-content-between align-items-center">
                    <span class="flex-grow-1">{{ section.name }}</span>
                    <button class="btn btn-sm btn-danger ml-2" @click.stop.prevent="removeSection(sidx)">
                        <i class="fas fa-trash-alt"></i>
                    </button>
                </div>
            </template>

            <table-list
                v-model="section.tables"
                :section_id="section.id"
            />
        </b-tab>

        <b-tab>
            <template #title>
                <div class="fs-lg px-4 text-center">{{ __t('ADD_SECTION') }}</div>
            </template>
            <div class="p-4" style="max-width: 360px;">
                <h5 class="frame-heading mb-3">{{ __t('ADD_SECTION') }}</h5>

                <div class="form-group">
                    <label class="form-label" for="new_section_name">{{ __t('NAME') }}</label>
                    <b-form-input
                        id="new_section_name"
                        v-model="new_section.name"
                        class="form-control form-control-use"
                        :placeholder="__t('NAME')"
                    ></b-form-input>
                </div>

                <div class="form-group">
                    <label class="form-label" for="new_section_uniq_id">{{ __t('UNIQ_ID_CAN_BE_EMPTY') }}</label>
                    <b-form-input
                        id="new_section_uniq_id"
                        v-model="new_section.uniq_id"
                        class="form-control form-control-use"
                        :placeholder="__t('UNIQ_ID_CAN_BE_EMPTY')"
                    ></b-form-input>
                </div>

                <button
                    class="btn btn-primary waves-effect waves-themed"
                    :disabled="!new_section.name"
                    @click="addSection"
                >
                    <i class="fal fa-plus mr-2"></i>{{ __t('ADD_SECTION') }}
                </button>
            </div>
        </b-tab>
    </b-tabs>
</template>

<script>
import TableList from './table_list.vue';

export default {
    name: "restaurant_table",

    props : {
        rest : {
            type : Object
        }
    },

    components: {
        TableList
    },

    data() {
        return {
            is_load: false,
            sections : [],
            new_section: {
                uniq_id: "",
                name: ""
            }
        }
    },


    methods : {
        addSection() {
            if (!this.new_section.name) return;

            const newSection = {
                id: 0,
                uniq_id: this.new_section.uniq_id,
                name: this.new_section.name,
                is_active: false,
                tables: []
            };

            if (!this.rest.hasOwnProperty("sections")) {
                this.$set(this.rest, 'sections', []);
            }

            this.$set(this.rest.sections, this.rest.sections.length, newSection);
            this.new_section = { uniq_id: "", name: "" };
        },

        removeSection(index) {
            this.rest.sections.splice(index, 1);
        }

    }

}
</script>


<style scoped>

</style>
